export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const API_BASE = (config.public as any)?.API_BASE_URL_IMG || ''

  const getImageSrc = (url?: string | null): string => {

    if (!url) return '/images/noimage.webp'

    // Ako već ima apsolutni URL (npr. http/https), vrati ga direktno
    if (/^https?:\/\//i.test(url)) {
      return url
    }

    // Ako sadrži /storage/ → dodaj API_BASE, ali samo ako ga već ne sadrži
    if (url.includes('/storage/')) {
      const cleanBase = API_BASE.replace(/\/+$/, '')


      if (url.startsWith(cleanBase) || url.includes(`${cleanBase}/`)) {
        return url
      }
      return `${cleanBase}/${url.replace(/^\/+/, '')}`
    }

    // Ako sadrži /api/img/ → ostavi kako jeste
    if (url.includes('/api/img/')) {
      return url
    }

    // fallback
    return '/images/noimage.webp'
  }

  nuxtApp.provide('getImageSrc', getImageSrc)
})
